<template>
  <AppSection :style="`--bg-img: url(${img.src})`" class="wrapper">
    <AppContainer>
      <div class="flex gap-7">
        <DesktopOnly class="image-wrapper border-lg" :aria-label="$t(img.alt!)" role="img" />
        <div class="features px-7">
          <h3 class="text-center mb-6 flex col items-center gap-2">
            <CountryFlag :code="getVisaCountryIsoCode(country)" end />
            {{ $tt(`page.product_features.title_${country}`) }}
          </h3>
          <div class="price-wrapper flex col gap-5">
            <div class="price flex col gap-5">
              <CountryKeyPointsSectionPoint
                :k="$tt('page.product_features.validity')"
                :v="tValidityRange(country)"
              />
              <CountryKeyPointsSectionPoint
                :k="$tt('page.product_features.processing')"
                :v="tWaitDays(country)"
              />
            </div>
            <div class="price flex col gap-5">
              <CountryKeyPointsSectionPoint :k="$tt('page.hero_price')">
                <template #v>
                  <FromPrice :price />
                </template>
              </CountryKeyPointsSectionPoint>
              <i
                v-if="!fee_partial && !consulate_payment_countries?.includes($branch.baseCountry)"
                class="equal"
              >
                {{ $tt('final_price_note') }}
              </i>
            </div>
          </div>
          <div class="flex justify-center mt-7">
            <AppBtn size="x-large" primary @click="ctaClickBus.emit()">
              {{ $tt('page.product_features.cta') }}
              <ChevronMarker dir="next" class="ms-2" />
            </AppBtn>
          </div>
        </div>
      </div>
    </AppContainer>
  </AppSection>
</template>

<script setup lang="ts">
import { getVisaCountryIsoCode } from '~/helpers/visa-country';
import type { Product, Image } from '~/types';

const props = defineProps<{
  img: Image;
  product: Product;
}>();

const { country, price, consulate_payment_countries, fee_partial } = props.product;

const { tWaitDays, tValidityRange } = useLocalization();
const { ctaClickBus } = useEmitter();
</script>

<style scoped lang="scss">
.image-wrapper {
  background-image: var(--bg-img);
  background-size: cover;
  background-position: center;
  width: 100%;
  height: auto;
  flex: 1;
}
.features {
  max-width: 360px;
}

@media (max-width: 850px) {
  .wrapper {
    background-image: 
      linear-gradient(to bottom, white 0%, white 55%, rgba(255, 255, 255, 0) 70%),
      var(--bg-img);
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;
    padding-bottom: 75%;
    margin-bottom: var(--space-8);
  }
  .features {
    max-width: none;
    width: 100%;
    padding: 0 var(--space-0) !important;
    h3 {
      margin-bottom: var(--space-6) !important;
    }
    .price-wrapper {
      gap: var(--space-3);
    }
    .price {
      flex-direction: row;
      justify-content: space-between;
    }
    p, span {
      font-size: 16px;
    }
    button {
      margin-top: var(--space-6) !important;
      width: 100%;
    }
  }
}
</style>